import React, { useEffect, useState } from "react";
import axios from "../../AxiosInstance";
import { Button, Table } from "antd";
import Header3 from "../../components/Header3";
import Footer2 from "../../components/Footer2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";
import Sidebar from "../../components/Sidebar";

import { Tooltip } from "antd"; // Make sure you have imported Tooltip from Ant Design
import { BASE_URL } from "../../config/BaseUrls";

const GetReviews = () => {
  const [reviews, setReviews] = useState([]); // ✅ Default empty array
  const [loading, setLoading] = useState(true); // Track loading state
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [users, setUsers] = useState([]); // ✅ Default empty array

  const [selectedBook, setSelectedBook] = useState(null);
  const [bookId, setBookId] = useState(null);

  useEffect(() => {
    const savedBook = JSON.parse(
      localStorage.getItem("selectedBookforreviews")
    );
    if (savedBook) {
      setSelectedBook(savedBook);
      setBookId(savedBook._id); // Extract the bookId from the saved book object
    }
  }, []);

  console.log("Book ID:", bookId); // To confirm if you're getting the correct bookId

  // Integration Reviews

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`api/v1/review/getallreviews`); // Fetching all reviews
      const reviewsData = response.data.reviews || [];

      console.log("All Reviews Data:", reviewsData); // 🔍 Check console for data

      setReviews(reviewsData);
      setAverageRating(response.data.averageRating);
      setTotalReviews(response.data.totalReviews);
      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch reviews");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews(); // Fetching all reviews without filtering by bookId
  }, []); // No dependency on bookId now

  const handleDownloadExcel = () => {
    if (!reviews || reviews.length === 0) {
      console.error("❌ No user reviews available");
      return;
    }

    // ✅ Convert users array to worksheet
    const worksheet = XLSX.utils.json_to_sheet(reviews);

    // ✅ Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reviews");

    // ✅ Convert workbook to binary data
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // ✅ Create a Blob and save as Excel file
    const excelFile = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(excelFile, "Reviews_List.xlsx");
  };

  const handleDeleteReview = async (reviewId) => {
    try {
      const res = await axios.delete(`/api/v1/auth/${reviewId}`);
      console.log(res.data.message);

      // ✅ Frontend se table refresh karna
      setReviews((prev) => prev.filter((review) => review._id !== reviewId));

      // ✅ Optional: Toast Success
      toast.success("Review deleted successfully");
    } catch (error) {
      console.error("Error deleting review:", error.response?.data?.message);
      toast.error(error.response?.data?.message || "Error deleting review");
    }
  };

  const columns = [
    {
      title: "Book",
      dataIndex: ["bookId", "coverImage"],
      key: "image",
      render: (text, record) => {
        const image = record.bookId?.coverImage;
        return image ? (
          <img
            src={`${BASE_URL}/uploadsbook/${image}`}
            alt="Book"
            style={{ width: "60px", height: "60px" }}
          />
        ) : (
          <span>No Image</span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: ["userId", "name"],
      key: "name",
    },
    {
      title: "Email",
      dataIndex: ["userId", "email"],
      key: "email",
    },

    {
      title: "BookKind",
      dataIndex: "bookKindss",
      key: "reviewsBookkind",
      render: (bookKindss) => (
        <span>
          {Array.isArray(bookKindss) && bookKindss.length > 0
            ? bookKindss.join(", ")
            : "N/A"}
        </span>
      ),
    },
    {
      title: "Review Title",
      dataIndex: "title",
      key: "reviewTitle",
      render: (text) => (
        <Tooltip
          placement="top"
          title={
            // Tooltip ke liye text ko directly return mat karna
            <div
              style={{
                maxWidth: "300px",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {text ? text : "N/A"}
            </div>
          }
        >
          <span
            style={{
              display: "inline-block",
              maxWidth: "220px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {text ? text : "N/A"}
          </span>
        </Tooltip>
      ),
    },

    {
      title: "Review",
      dataIndex: "description",
      key: "reviewDescription",
      render: (text) => (
        <Tooltip
          placement="top"
          title={
            // Tooltip ke liye text ko directly return mat karna
            <div
              style={{
                maxWidth: "300px",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {text ? text : "N/A"}
            </div>
          }
        >
          <span
            style={{
              display: "inline-block",
              maxWidth: "220px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {text ? text : "N/A"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      render: (rating) => (
        <div className="text-warning" style={{ fontSize: "20px" }}>
          {"★".repeat(rating)}
          {"☆".repeat(5 - rating)}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="primary"
          danger
          size="small"
          onClick={() => handleDeleteReview(record._id)}
        >
          Cancel
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="d-md-flex gap-2 ">
        <Sidebar />
        <div className="containerr w-full px-4  prrrt pb-5">
          <h1 className="text-center mt-4">Reviews </h1>
          <div className=".ant-table-container ">
            {reviews.length > 0 ? (
              <>
                <Table
                  columns={columns}
                  dataSource={reviews}
                  pagination={{ pageSize: 5 }}
                  scroll={{ x: "700px" }} // 👈 Yeh line add karni hai
                />
                <div className="d-flex justify-content-end">
                  <button
                    className="text-white    subbtnmeet border-0 fs-18 fw600 rounded-1"
                    style={{
                      width: "135px",
                      height: "44px",
                      backgroundColor: "#62C0C7",
                    }}
                    onClick={handleDownloadExcel}
                    disabled={reviews.length === 0}
                  >
                    Download
                  </button>
                </div>
              </>
            ) : (
              <p className="text-center">Loading review...</p>
            )}
          </div>
        </div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
};

export default GetReviews;
